export default "__VITE_ASSET__CcHLpUl7__"